<div class="page-title-area">
  <div class="container-custom">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/centros-propios-listado">Listado de Centros Propios</a></li>
      </ul>
      <h2>Modificar Centro Propio</h2>
      <h4 *ngIf="catalogo">{{ catalogo.concepto }}</h4>
    </div>
  </div>
</div>

<div class="form-wrapper padding-70 animate__animated animate__fadeIn">
  <div class="container-custom">
    <div class="form-row justify-content-center">
      <div class="form-col-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="put()">

            <!-- Nombre y Activo -->
            <div class="form-row">
              <div class="form-col-8">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Centro propio</mat-label>
                    <input formControlName="centro" matInput placeholder="Centro propio"
                      [class.is-invalid]="centroNoValido" autocomplete="off">
                    <mat-error *ngIf="centroNoValido">Ingrese un nombre de centro propio</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-4">
                <div class="form-group">
                  <mat-slide-toggle formControlName="activa">Activo</mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- Teléfono -->
            <div class="form-row">
              <div class="form-col-12">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Teléfono</mat-label>
                    <input formControlName="telefono" matInput placeholder="Ingrese Teléfono" autocomplete="off">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Fila de Calle, Altura y Botón de búsqueda -->
            <div class="form-row">
              <div class="form-col-6">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Calle</mat-label>
                    <input type="text" matInput
                           [formControl]="calleControl"
                           [matAutocomplete]="auto"
                           (input)="onCalleInput()"
                           placeholder="Ej: Av. Corrientes"
                           [class.is-invalid]="calleNoValida"
                           autocomplete="off">
                    <mat-autocomplete #auto="matAutocomplete" 
                                      (optionSelected)="onCalleSelected($event)"
                                      [displayWith]="displayCalleFn">
                      <mat-option *ngFor="let suggestion of calleSuggestions" [value]="suggestion">
                        {{ suggestion.place_name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="calleNoValida">Ingrese una calle</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-4">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Altura</mat-label>
                    <input formControlName="altura" matInput placeholder="Número"
                           [class.is-invalid]="alturaNoValida" autocomplete="off"
                           (keyup.enter)="buscarDireccionCompleta()">
                    <mat-error *ngIf="alturaNoValida">Ingrese una altura</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-2">
                <button mat-raised-button type="button" class="btn-search-map" 
                        (click)="buscarDireccionCompleta()" 
                        [disabled]="!form.get('calle')?.value || !form.get('altura')?.value">
                  Buscar
                </button>
              </div>
            </div>

            <!-- Coordenadas (ocultas) -->
            <div class="form-row" hidden>
              <div class="form-col-6">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Latitud</mat-label>
                    <input formControlName="latitud" matInput placeholder="Latitud" autocomplete="off"
                      (change)="updatesCoordinates()" (input)="updateMarkerLocation()">
                    <mat-error *ngIf="form.get('latitud')?.hasError('pattern')">Ingrese una latitud válida.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-6">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Longitud</mat-label>
                    <input formControlName="longitud" matInput placeholder="Longitud" autocomplete="off"
                      (change)="updatesCoordinates()" (input)="updateMarkerLocation()">
                    <mat-error *ngIf="form.get('longitud')?.hasError('pattern')">Ingrese una longitud válida.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Mapa -->
            <div class="form-row">
              <div class="form-col-12">
                <app-map></app-map>
              </div>
            </div>

            <!-- Botones centrados -->
            <div class="form-actions">
              <button mat-stroked-button class="btn-cancel" type="button" routerLink="/centros-propios-listado">
                Cancelar
              </button>
              <button mat-raised-button class="btn-save" [disabled]="!form.valid" type="submit">
                Guardar
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>